const SquashTypes = {
    GET_SQUASH_START:'GET_SQUASH_START',
    GET_SQUASH_SUCCESS:'GET_SQUASH_SUCCESS',
    GET_SQUASH_FAILED:'GET_SQUASH_FAILED',

}

export default SquashTypes